import { Component, inject } from '@angular/core';
import { ConfigService } from '../../../services/config.service';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../services/auth.service';
import { UserFacade } from 'src/app/_core/state/user/user.facade';

@Component({
  template: '',
  styleUrls: ['user-actions-book-clubs.component.scss'],
})
export class UserActionsBookClubsComponent {
  readonly userFacade = inject(UserFacade);

  bookSection = 'section=';

  constructor(
    public configService: ConfigService,
    public authService: AuthService,
    public apiService: ApiService
  ) { }

  goToBookClub(section: string) {
    const wnd = window.open();
    const userId = this.authService.isAuthenticated() ? this.userFacade.user.id : null;

    const params = {
      section: section,
      patronId: userId,
    };

    this.apiService.getLinkToBookclub(params).subscribe((url) => {
      if (!url.includes('section')) {
        url = url + '&section=' + params['section'];
      }
      wnd.location.href = url;
    });
  }
}
